import Head from "next/head";
import {useTranslation} from "react-i18next";

type Props = { q: string, country: string | undefined };
export const Header = ({q, country}: Props) => {
  const { t } = useTranslation();
  return (
    <div className='nav-divider'>
      <Head>
        <title>
          {q ? `${q} -` : ''} {country ?? t('Search')}
        </title>
      </Head>
      <div className='app-container'>
        <nav>
          <div className='logo-container mobile-only'>
            <img
              src='/logo.png'
              alt='Mercheo Logo'
              className='logo'
            />
          </div>
          <form method='get' className='search-form'>
            <input
              type='text'
              name='q'
              placeholder='Enter search keyword'
              defaultValue={q}
            />
            <button className='search-button' type='submit'>
              <svg className="icon-search" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                   xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </button>
          </form>
          <div className='logo-container desktop-only'>
            <img
              src='/logo.png'
              alt='Mercheo Logo'
              className='logo'
            />
          </div>
        </nav>
      </div>
    </div>
  );
};
